import React, { useState } from "react";

import { Form, Input, Select, Checkbox, Button, Row, Col, Tag } from "antd";
import { Link } from "react-router-dom";
import axios from "axios";

const { Option } = Select;

export function GetADemoForm(props) {
  const [status, setStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setDisableBtn(true);
    try {
      const response = await axios.post(
        "https://www.alpacasys.com/form/sendAlpacaForm",
        {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          jobTitle: values.jobTitle,
          country: values.country,
          phone: values.phone,
          company: values.company,
          employees: values.employees,
          message: values.message,
          terms: values.terms || false,
        }
      );

      console.log("Form submitted successfully:", response.data);
      setStatus("success");
      setStatusMessage("Your request has been submitted!");
      form.resetFields();
      setDisableBtn(false);
    } catch (error) {
      setDisableBtn(true);

      console.error("Error submitting form:", error);

      setStatus("error");
      setStatusMessage("Something went wrong. Please try again.");
      setDisableBtn(false);
    }
  };

  return (
    <Form form={form} name="demo_request" layout="vertical" onFinish={onFinish}>
      <h3 className="subhead mb-2">
        Fill out the form and we'll get back to you
      </h3>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: true }]}
          >
            <Input placeholder="First name" size="large" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[{ required: true }]}
          >
            <Input placeholder="Last name" size="large" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Work email"
            name="email"
            rules={[{ type: "email", required: true }]}
          >
            <Input placeholder="mail@company.com" size="large" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Form.Item label="Job title" name="jobTitle">
            <Input placeholder="Ex: Safety Administrator" size="large" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Country"
            name="country"
            rules={[{ required: true }]}
          >
            <Input placeholder="Canada" size="large" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Phone number"
            name="phone"
            rules={[{ required: true }]}
          >
            <Input placeholder="Ex: 403-123-4567" size="large" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Company name"
            name="company"
            rules={[{ required: true }]}
          >
            <Input placeholder="Ex: ABC Manufacturing" size="large" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Number of employees"
            name="employees"
            rules={[{ required: true }]}
          >
            <Select placeholder="Choose from the list" size="large">
              <Option value="1-10">1-10</Option>
              <Option value="11-50">11-50</Option>
              <Option value="51-200">51-200</Option>
              <Option value="201-500">201-500</Option>
              <Option value="500+">500+</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Message" name="message">
        <Input.TextArea
          rows={4}
          placeholder="Tell us how we can make your manufacturing life easier"
        />
      </Form.Item>

      <Form.Item label={null} name="terms" rules={[{ required: true }]}>
        <Row>
          <Col>
            <Checkbox style={{ marginRight: 8 }} />
          </Col>
          <Col>
            I agree to the <Link to="/privacy-statement"> Privacy Policy</Link>
          </Col>
        </Row>
      </Form.Item>

      <Form.Item>
        <button
          type="primary"
          htmlType="submit"
          block
          className="roundBtn"
          style={{
            width: "100%",
            cursor: disableBtn ? "not-allowed" : "pointer",
          }}
          disabled={disableBtn}
        >
          Send to sales
        </button>
      </Form.Item>
      {status && (
        <Tag
          color={status === "success" ? "#87d068" : "#f50"}
          style={{ marginTop: 8, fontSize: "12pt", padding: 8 }}
        >
          {statusMessage}
        </Tag>
      )}
    </Form>
  );
}
